import { getTranslation } from '../../../../utils/translations';
import translations from './translations';
import { HOUSE_TYPES, OBJECT_GROUP_TYPE, TYPES_OF_USAGE, PURPOSES_OF_USE, TIME_OF_DEMAND, PROJECT_STATUSES, } from './formModel.types';
var t = getTranslation(translations);
var objectTypesGroupOptions = [
    { value: OBJECT_GROUP_TYPE.HOUSE, label: t.objectTypesGroup_house },
    {
        value: OBJECT_GROUP_TYPE.APARTMENTS,
        label: t.objectTypesGroup_apartments,
    },
    { value: OBJECT_GROUP_TYPE.PROPERTY, label: t.objectTypesGroup_property },
];
var houseTypeOptions = [
    {
        value: HOUSE_TYPES.SINGLE_FAMILY_HOUSE,
        label: t.houseType_singleFamilyHouse,
    },
    { value: HOUSE_TYPES.TOWN_HOUSE, label: t.houseType_townhouse },
    { value: HOUSE_TYPES.SEMI_DETACHED_HOUSE, label: t.houseType_semiDetached },
    {
        value: HOUSE_TYPES.TWO_FAMILY_HOUSE,
        label: t.houseType_twoFamilyHouse,
    },
    {
        value: HOUSE_TYPES.APARTMENT_HOUSE,
        label: t.houseType_appartmentHouse,
    },
];
var yesNoOptions = [
    { value: true, label: t.yes },
    { value: false, label: t.no },
];
var objectTypeOfUseOptions = [
    { value: TYPES_OF_USAGE.SELF_USED, label: t.objectTypeOfUse_selfUsed },
    { value: TYPES_OF_USAGE.RENTED, label: t.objectTypeOfUse_rented },
    {
        value: TYPES_OF_USAGE.PARTLY_RENTED,
        label: t.objectTypeOfUse_partlyRented,
    },
];
var purposeOfUseOptions = [
    { value: PURPOSES_OF_USE.CONSTRUCTION, label: t.reasonOfLoan_construction },
    {
        value: PURPOSES_OF_USE.PURCHASE_EXISTING_HOME,
        label: t.reasonOfLoan_purchaseExistingHome,
    },
    { value: PURPOSES_OF_USE.MODERNIZATION, label: t.reasonOfLoan_modernization },
    {
        value: PURPOSES_OF_USE.PROLONGATION,
        label: t.reasonOfLoan_prolongation,
    },
    { value: PURPOSES_OF_USE.PROCUREMENT, label: t.reasonOfLoan_procurement },
];
var loanTimeOfDemandOptions = [
    { value: TIME_OF_DEMAND.AT_ONCE, label: t.loanTimeOfDemand_AT_ONCE },
    {
        value: TIME_OF_DEMAND.ONE_TO_THREE_MONTHS,
        label: t.loanTimeOfDemand_ONE_TO_THREE_MONTHS,
    },
    {
        value: TIME_OF_DEMAND.FOUR_TO_SIX_MONTHS,
        label: t.loanTimeOfDemand_FOUR_TO_SIX_MONTHS,
    },
    {
        value: TIME_OF_DEMAND.MORE_THAN_SIX_MONTHS,
        label: t.loanTimeOfDemand_MORE_THAN_SIX_MONTHS,
    },
    { value: TIME_OF_DEMAND.UNKNOWN, label: t.loanTimeOfDemand_UNKNOWN },
];
var projectStatusOptionsForConstruction = [
    { value: PROJECT_STATUSES.PARCEL_FOUND, label: t.projectStatus_PARCEL_FOUND },
    { value: PROJECT_STATUSES.NOTARY, label: t.projectStatus_NOTARY },
    { value: PROJECT_STATUSES.PARCEL_OWNED, label: t.projectStatus_PARCEL_OWNED },
    {
        value: PROJECT_STATUSES.DEVELOPER_CONTRACTED,
        label: t.projectStatus_DEVELOPER_CONTRACTED,
    },
];
var projectStatusOptionsForPurchase = [
    { value: PROJECT_STATUSES.OBJECT_FOUND, label: t.projectStatus_OBJECT_FOUND },
    {
        value: PROJECT_STATUSES.OBJECT_INSPECTED,
        label: t.projectStatus_OBJECT_INSPECTED,
    },
    { value: PROJECT_STATUSES.NEGOTIATION, label: t.projectStatus_NEGOTIATION },
    { value: PROJECT_STATUSES.NOTARY, label: t.projectStatus_NOTARY },
];
var projectStatusOptionsForPropertyPurchase = [
    {
        value: PROJECT_STATUSES.OBJECT_FOUND,
        label: t.projectStatus_PROPERTY_OBJECT_FOUND,
    },
    {
        value: PROJECT_STATUSES.OBJECT_INSPECTED,
        label: t.projectStatus_PROPERTY_OBJECT_INSPECTED,
    },
    { value: PROJECT_STATUSES.NEGOTIATION, label: t.projectStatus_NEGOTIATION },
    { value: PROJECT_STATUSES.NOTARY, label: t.projectStatus_NOTARY },
];
var purposeOfUseWithRequiredAddress = [
    PURPOSES_OF_USE.PROCUREMENT,
    PURPOSES_OF_USE.PROLONGATION,
    PURPOSES_OF_USE.MODERNIZATION,
];
export default {
    loanTimeOfDemandOptions: loanTimeOfDemandOptions,
    objectTypesGroupOptions: objectTypesGroupOptions,
    houseTypeOptions: houseTypeOptions,
    yesNoOptions: yesNoOptions,
    objectTypeOfUseOptions: objectTypeOfUseOptions,
    purposeOfUseOptions: purposeOfUseOptions,
    purposeOfUseWithRequiredAddress: purposeOfUseWithRequiredAddress,
    projectStatusOptionsForConstruction: projectStatusOptionsForConstruction,
    projectStatusOptionsForPurchase: projectStatusOptionsForPurchase,
    projectStatusOptionsForPropertyPurchase: projectStatusOptionsForPropertyPurchase,
};
